export enum Language {
  English = 'en',
  Serbian = 'sr',
  French = 'fr',
  German = 'ge',
}
